import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HeroSection from "./components/HeroSection";
import Locations from "./components/Locations";
import { AudioProvider } from "./components/AudioContext"; // Import the audio provider
import Instructions from "./components/Instructions";
import Whatsapp from "./components/whatsapp"
import Creator from './components/creator'; 
import ISBRsvp from './components/ISBRsvp';
import GreaterNoidaInfo from './components/GreaterNoidaInfo';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';

import Game from "./components/game";


function App() {
  return (
    <HelmetProvider>
    <AudioProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HeroSection />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/game" element={<Game />} />
          <Route path="/gurugram" element={<Instructions />} />
          <Route path="/creator" element={<Creator />} />
          <Route path="/isb-rsvp" element={<ISBRsvp />} />
          <Route path="/greater-noida" element={<GreaterNoidaInfo />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
        </Routes>

        <Whatsapp/>
      </Router>
    </AudioProvider>
    </HelmetProvider>
  );
}

export default App;